
import getWidgetQuery from "/public/graphQl/queries/getWidgetHost";
// import {getAllBalances} from "../../balances/actions/getAllBalances";
export const fetchWidgetHost = async ({state, commit, rootGetters, dispatch}, widgetId) => {
    if (state.loading) {
        return;
    }

    commit('setLoading', true);

    const organizationId = rootGetters['app/getSelectedOrganization'].id;
    let data;
    try {
        data = await dispatch('app/request', {
            type: 'query',
            gql: getWidgetQuery,
            variables: { organizationId},
        }, {root: true});
    } catch (error) {
        console.error('Fail fetch accounts', error);
    } finally {
        commit('setLoading', false);
    }

    const {
        data: {
            IFrameWidgetsHost: host,
        },
    } = data;


    commit('setHost', host);

    return host;
};
